import { Badge } from '@/components/ui/badge';
import { MapPin, X } from 'lucide-react';
import { MARKER_COLORS } from './constants';

export const ResourceCard = ({ resource, user, onDelete }) => {
  const isOwner = user?.user_id === resource.added_by;
  const isAdmin = user?.role === 'admin' || user?.is_admin;
  const canDelete = isOwner || isAdmin;
  const catColor = MARKER_COLORS[resource.category] || MARKER_COLORS.other;
  return (
    <div className="flex items-center justify-between p-3 rounded-lg bg-card/40 border border-border/40" data-testid={`resource-${resource.resource_id}`}>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <MapPin className="w-3.5 h-3.5 flex-shrink-0" style={{ color: catColor }} />
          <span className="text-sm font-medium text-foreground truncate">{resource.name}</span>
          <Badge variant="outline" className="text-[9px]" style={{ borderColor: `${catColor}60`, color: catColor }}>{resource.category}</Badge>
        </div>
        {resource.address && <p className="text-[11px] text-muted-foreground mt-0.5 ml-5 truncate">{resource.address}</p>}
        {resource.hours && <p className="text-[10px] text-muted-foreground ml-5 truncate">{resource.hours}</p>}
        {resource.description && <p className="text-[10px] text-muted-foreground ml-5 mt-0.5 line-clamp-2 break-all">{resource.description}</p>}
      </div>
      {canDelete && (
        <button onClick={() => onDelete(resource.resource_id)} className="p-1 rounded hover:bg-muted text-muted-foreground hover:text-red-400 transition-colors">
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
